// ----------------------------------------------------------------------------- //
// 	Load video background
// ----------------------------------------------------------------------------- //
export default function loadVideoBackground( ref = document ) {

	const videoBg = ref.querySelectorAll('.background__video');

	if ( videoBg.length ) {
		videoBg.forEach( (e) => {

			// Determine screen size and select mobile or desktop video
			const windowWidth = window.innerWidth ? window.innerWidth : $(window).width();
			const desktopVideo = e.getAttribute("data-src");
			const mobileVideo = e.getAttribute("data-mobile-src");

			if ( windowWidth >= 720 ) {
				e.setAttribute("src", desktopVideo);
			} else {
				const source = mobileVideo != undefined ? mobileVideo : desktopVideo;
				e.setAttribute("src", source);
			}

			// Make sure the video has loaded and then trigger the play() function
			const playPromise = e.play();

			if ( playPromise !== undefined ) {
				playPromise.then(() => {}).catch(() => {});
			}
		});
	}
};
